<template>
  <div>
    <div
      class="t3m-ObjectiveFinder-shopPanel min-h-10"
      data-dmf-plugin="collector:contentModifiers:intershopProduct:shop:main"
      :data-dmf-sku="objective.sku"
      :data-dmf-availabletopurchase="objective.availabletopurchase.join(',')"
      data-dmf-product-type="bundle"
      style="display: none;"
    >
      <form
        class="t3m-ObjectiveFinder-shopPanel-form"
        data-dmf-plugin="distributor:shop"
        data-dmf-plugin-snippet="form"
      >
        <input type="hidden" name="cart_type" value="quote" />
        <input type="hidden" name="product_type" value="product" />
        <input
          type="hidden"
          name="referrer"
          data-dmf-attribute
          :data-dmf-attribute-value="'{{referrer}}'"
        />
        <input
          type="hidden"
          name="referrer_title"
          data-dmf-attribute
          :data-dmf-attribute-value="'{{referrerTitle}}'"
        />
        <input type="hidden" name="product_name" :value="objective.objectiveName" />
        <input type="hidden" name="sku" :value="objective.sku" />
        <input type="hidden" name="submit_type" value="stay" />
        <input
          type="hidden"
          name="basket_id"
          value=""
          data-dmf-attribute
          :data-dmf-attribute-value="'{{basketId}}'"
        />
        <input
          type="hidden"
          name="packing_unit"
          data-dmf-attribute
          :data-dmf-attribute-value="'{{packingUnit}}'"
        />

        <div data-dmf-plugin-snippet="cart_section" class="text-right">
          <span
            class="block mb-0 h4 text-t3m-muted"
            data-dmf-plugin-snippet="cart_section_list_price_when_sale"
            style="display:none;"
          >
            <span
              class="line-through"
              :data-dmf-content="'{{listPriceValueFormatted}}'"
            ></span>
            <span
              class="text-[length:70%] line-through ms-1"
              :data-dmf-content="'{{listPriceCurrency}}'"
            ></span>
          </span>

          <div
            class="mb-2"
            data-dmf-plugin-snippet="cart_section_list_price"
            style="display:none;"
          >
            <span
              class="h1 lg:h2 !mb-0"
              :data-dmf-content="'{{listPriceValueFormatted}}'"
            ></span>
            <span
              class="h5 ms-1 !mb-0"
              :data-dmf-content="'{{listPriceCurrency}}'"
            ></span>
          </div>

          <div
            class="mb-2"
            data-dmf-plugin-snippet="cart_section_sale_price"
            style="display:none;"
          >
            <span
              class="h1 lg:h2 !mb-0"
              :data-dmf-content="'{{salePriceValueFormatted}}'"
            ></span>
            <span class="h5 !mb-0" :data-dmf-content="'{{salePriceCurrency}}'"></span>
          </div>
        </div>

        <div style="display:none;" data-dmf-plugin-snippet="no_cart_section">
          <div class="h4 !mb-2 text-t3m-muted text-right">
            Request for Price
          </div>
        </div>

        <div
          class="flex gap-2 flex-wrap items-baseline t3m-small text-t3m-muted mb-4 justify-end font-sans text-xs"
        >
          <span
            :data-dmf-content="'Min. Order Qty: {{minOrderQuantity}}'"
          ></span>
          <span
            :data-dmf-content="'Unit of Measure: {{packingUnitDisplay}}'"
          ></span>
        </div>

        <div class="flex justify-end items-start mb-5">
          <div class="relative bg-white rounded-md">
            <button
              class="t3m-ObjectiveFinder-shopPanel-decreaseButton absolute w-8 left-12 lg:left-auto right-10 top-1 bottom-1 rounded p-1.5 border hover:border-secondary hover:text-secondary text-t3m-muted border-t3m-border-color text-center  text-sm flex justify-center items-center"
              type="button"
              @click="decreaseAmount"
            >
              –
            </button>
            <button
              class="t3m-ObjectiveFinder-shopPanel-increaseButton absolute left-20.5 lg:left-auto right-1 w-8 top-1 bottom-1 rounded p-1.5 border hover:border-secondary hover:text-secondary text-t3m-muted border-t3m-border-color text-center text-sm flex justify-center items-center"
              type="button"
              @click="increaseAmount"
            >
              +
            </button>
            <input
              ref="amountInput"
              type="number"
              name="quantity"
              value="0"
              class="t3m-ObjectiveFinder-shopPanel-amountInput w-32 bg-transparent text-sm border border-t3m-border-color rounded-md pl-3 pr-20 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              data-dmf-attribute
              :data-dmf-attribute-value="'{{minOrderQuantity}}'"
              :data-dmf-attribute-min="'{{minOrderQuantity}}'"
              :data-dmf-attribute-max="'{{maxOrderQuantity}}'"
              :data-dmf-attribute-step="'{{stepOrderQuantity}}'"
            />
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex flex-wrap items-center justify-end gap-2">
          <span data-dmf-plugin-snippet="cart_section">
            <button
              class="flex items-center btn btn-sm btn-primary"
              data-dmf-name="cart_type"
              data-dmf-value="cart"
              type="submit"
            >
              <span
                class="t3m-ObjectiveFinder-shopPanel-spinner justify-center items-center hidden mr-2"
              >
                <span
                  class="inline-block text-current border-t border-current rounded-full w-em h-em animate-spin"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </span>
              </span>
              Add to cart
            </button>
          </span>

          <button
            class="flex items-center btn btn-sm btn-secondary"
            data-dmf-name="cart_type"
            data-dmf-value="quote"
            type="submit"
          >
            <span
              class="t3m-ObjectiveFinder-shopPanel-spinner justify-center items-center hidden mr-2"
            >
              <span
                class="inline-block text-current border-t border-current rounded-full w-em h-em animate-spin"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </span>
            </span>
            Add to quote cart
          </button>
        </div>
      </form>
    </div>

    <div
      class="t3m-ObjectiveFinder-shopPanelSpinner z-10 hidden items-center justify-center"
    >
      <div
        class="w-8 h-8 border-t-2 rounded-full animate-spin border-primary text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopPanel',

  data() {
    return {}
  },

  props: {
    objective: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    increaseAmount() {
      const inputEl = this.$refs.amountInput
      const currentValue = Number(inputEl.value) || 0
      const step = Number(inputEl.step) || 1
      const max = Number(inputEl.max) || Infinity
      let newValue = currentValue + step
      if (newValue > max) {
        newValue = max
      }
      inputEl.value = newValue
    },
    decreaseAmount() {
      const inputEl = this.$refs.amountInput
      const currentValue = Number(inputEl.value) || 0
      const step = Number(inputEl.step) || 1
      const min = Number(inputEl.min) || 0
      let newValue = currentValue - step
      if (newValue < min) {
        newValue = min
      }
      inputEl.value = newValue
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$dmfRescan()
    })
  },
}
</script>
